import { useEffect } from "react"
import { FullScreenLoadingCover } from "@prosolve/common-components-ui"
import useDataJobs from "../../dataHooks/useDataJobs"
import EmailModal from "./EmailModal"

export default ({
  attendeeForEvent,
  onClose
}) => {
  const { isLoading, composeAttendeesEventCertificatesEmail, fetchComposeAttendeeEventCertificateEmail } = useDataJobs()

  const {
    eventId,
    eventName,
    eventStartDate
  } = attendeeForEvent || {}

  const attendee = attendeeForEvent
  const event = {
    id: eventId,
    name: eventName,
    startDate: eventStartDate
  }

  useEffect(() => {
    fetchComposeAttendeeEventCertificateEmail({ attendee, event })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {
        isLoading || !composeAttendeesEventCertificatesEmail
        ?
        <FullScreenLoadingCover />
        :
        <EmailModal email={composeAttendeesEventCertificatesEmail} onClose={onClose} />
      }
    </>
  )
}
